import Layout from "../layout/Layout";
import Section from "../layout/Section";
import "./inquiryDashboard.css";

const InquiryDashboard = (props) => {
  return (
    <Layout>
      <Section>
        <div className="flex flex-col h-full w-full max-w-[1800px] mx-auto p-4 sm:p-6 lg:p-8 overflow-hidden">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 flex-shrink-0">
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-corporate-text">
                Inquiry Management
              </h2>
              <div className="flex items-center gap-2 mt-1">
                <span className="w-2 h-2 rounded-full bg-primary"></span>
                <span className="text-xs text-slate-500 font-medium">
                  1,284 total inquiries found
                </span>
              </div>
            </div>
            <div className="flex items-center">
              <button className="w-full sm:w-auto bg-primary hover:bg-[#28a364] text-white px-5 py-2.5 rounded-lg text-sm font-bold flex items-center justify-center gap-2 transition-all shadow-sm">
                <span className="material-symbols-outlined">add</span>
                <span>New Inquiry</span>
              </button>
            </div>
          </div>
          <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm mb-6 flex-shrink-0">
            <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-4">
              <div className="flex-grow flex items-center gap-0">
                <div className="relative">
                  <select className="h-10 pl-3 pr-8 bg-slate-50 border border-slate-200 border-r-0 rounded-l-lg text-xs font-bold text-slate-600 appearance-none cursor-pointer focus:ring-0 focus:border-slate-200">
                    <option>Name</option>
                    <option>Phone</option>
                    <option>Email</option>
                  </select>
                  <span className="material-symbols-outlined absolute right-2 top-1/2 -translate-y-1/2 text-[16px] text-slate-400 pointer-events-none">
                    expand_more
                  </span>
                </div>
                <div className="relative flex-grow">
                  <input
                    className="w-full pl-10 pr-3 h-10 input-standard rounded-l-none"
                    placeholder="Search inquiries..."
                    type="text"
                  />
                  <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                    search
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-3">
                <button className="toggle-btn toggle-btn-inactive">
                  <span className="material-symbols-outlined">
                    person_search
                  </span>
                  <span>Unclaimed</span>
                </button>
                <div className="h-6 w-[1px] bg-slate-200 hidden lg:block"></div>
                <div className="relative min-w-[200px]">
                  <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-base pointer-events-none">
                    calendar_month
                  </span>
                  <input
                    className="w-full pl-10 pr-3 h-10 input-standard cursor-pointer font-medium text-xs"
                    readOnly
                    type="text"
                    value="Jan 1 - Jan 31, 2025"
                  />
                </div>
                <button className="text-xs font-bold text-slate-400 hover:text-primary px-2">
                  Reset Filters
                </button>
              </div>
            </div>
          </div>
          <div className="custom-table-container">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th className="w-10 text-center">Claimed</th>
                  <th>Contact Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Source</th>
                  <th>Event Date</th>
                  <th>Event Type</th>
                  <th>Status</th>
                  <th>Handler</th>
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th className="text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                <tr className="hover:bg-slate-50/50 transition-colors group">
                  <td className="text-slate-400 font-mono text-[11px]">8824</td>
                  <td className="text-center">
                    <span
                      className="material-symbols-outlined text-primary"
                      style={{ fontVariationSettings: "'FILL' 1" }}
                    >
                      check_circle
                    </span>
                  </td>
                  <td className="font-bold text-corporate-text">
                    Sarah Jenkins
                  </td>
                  <td className="text-slate-600">+1 415-555-0123</td>
                  <td className="text-slate-500">s.jenkins@mail.com</td>
                  <td>
                    <span className="flex items-center gap-1.5 text-xs text-slate-600">
                      <span className="material-symbols-outlined text-[14px] text-blue-500">
                        hub
                      </span>
                      Referral
                    </span>
                  </td>
                  <td className="font-semibold">Oct 24, 2025</td>
                  <td>
                    <span className="text-[10px] font-bold uppercase text-slate-500 tracking-wider">
                      Business
                    </span>
                  </td>
                  <td>
                    <span className="inline-flex px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-green-50 text-green-700 border border-green-100">
                      Definite
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="size-6 rounded-full bg-primary/10 flex items-center justify-center text-[10px] font-bold text-primary">
                        A
                      </div>
                      <span className="text-xs font-medium">Alex (Sales)</span>
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="size-6 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600">
                        SC
                      </div>
                      <span className="text-xs font-medium">Sarah Chen</span>
                    </div>
                  </td>
                  <td className="text-slate-400 text-[11px]">
                    Jan 8, 2025, 2:45 PM
                  </td>
                  <td className="text-right">
                    <div className="flex items-center justify-end gap-1">
                      <button className="p-1.5 hover:bg-slate-100 rounded text-slate-400 hover:text-primary transition-all">
                        <span className="material-symbols-outlined">
                          visibility
                        </span>
                      </button>
                      <button className="p-1.5 hover:bg-slate-100 rounded text-slate-400 hover:text-primary transition-all">
                        <span className="material-symbols-outlined">edit</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr className="hover:bg-slate-50/50 transition-colors group">
                  <td className="text-slate-400 font-mono text-[11px]">8825</td>
                  <td className="text-center">
                    <span className="material-symbols-outlined text-slate-200">
                      circle
                    </span>
                  </td>
                  <td className="font-bold text-corporate-text">
                    Marcus Thornton
                  </td>
                  <td className="text-slate-600">+1 202-555-0199</td>
                  <td className="text-slate-500">m.thornton@gmail.com</td>
                  <td>
                    <span className="flex items-center gap-1.5 text-xs text-slate-600">
                      <span className="material-symbols-outlined text-[14px] text-slate-400">
                        language
                      </span>
                      Website
                    </span>
                  </td>
                  <td className="font-semibold">Nov 12, 2025</td>
                  <td>
                    <span className="text-[10px] font-bold uppercase text-slate-500 tracking-wider">
                      Private
                    </span>
                  </td>
                  <td>
                    <span className="inline-flex px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-orange-50 text-orange-700 border border-orange-100">
                      Tentative
                    </span>
                  </td>
                  <td>
                    <span className="text-[11px] text-slate-400 italic font-medium">
                      Unassigned
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="size-6 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600">
                        JW
                      </div>
                      <span className="text-xs font-medium">James Wu</span>
                    </div>
                  </td>
                  <td className="text-slate-400 text-[11px]">
                    Jan 9, 2025, 10:12 AM
                  </td>
                  <td className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <button className="px-3 py-1.5 bg-primary text-white text-[10px] font-bold uppercase rounded shadow-sm hover:bg-[#28a364]">
                        Claim
                      </button>
                    </div>
                  </td>
                </tr>
                <tr className="hover:bg-slate-50/50 transition-colors group">
                  <td className="text-slate-400 font-mono text-[11px]">8826</td>
                  <td className="text-center">
                    <span
                      className="material-symbols-outlined text-primary"
                      style={{ fontVariationSettings: "'FILL' 1" }}
                    >
                      check_circle
                    </span>
                  </td>
                  <td className="font-bold text-corporate-text">
                    TechNova Corp
                  </td>
                  <td className="text-slate-600">+1 305-555-0442</td>
                  <td className="text-slate-500">admin@technova.co</td>
                  <td>
                    <span className="flex items-center gap-1.5 text-xs text-slate-600">
                      <span className="material-symbols-outlined text-[14px] text-red-400">
                        call
                      </span>
                      Direct
                    </span>
                  </td>
                  <td className="font-semibold">Dec 01, 2025</td>
                  <td>
                    <span className="text-[10px] font-bold uppercase text-slate-500 tracking-wider">
                      Business
                    </span>
                  </td>
                  <td>
                    <span className="inline-flex px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-red-50 text-red-700 border border-red-100">
                      Cancelled
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="size-6 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600">
                        S
                      </div>
                      <span className="text-xs font-medium">Sarah (M)</span>
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="size-6 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600">
                        ML
                      </div>
                      <span className="text-xs font-medium">Mike Lee</span>
                    </div>
                  </td>
                  <td className="text-slate-400 text-[11px]">
                    Jan 7, 2025, 4:30 PM
                  </td>
                  <td className="text-right">
                    <div className="flex items-center justify-end gap-1">
                      <button className="p-1.5 hover:bg-slate-100 rounded text-slate-400">
                        <span className="material-symbols-outlined">
                          visibility
                        </span>
                      </button>
                      <button className="p-1.5 hover:bg-slate-100 rounded text-slate-400">
                        <span className="material-symbols-outlined">
                          more_vert
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 flex-shrink-0">
            <p className="text-xs font-medium text-slate-500">
              Showing 1-10 of 1,284 entries
            </p>
            <div className="flex items-center gap-1.5">
              <button
                className="p-2 border border-slate-200 rounded-lg hover:bg-white text-slate-400 disabled:opacity-30"
                disabled
              >
                <span className="material-symbols-outlined">chevron_left</span>
              </button>
              <button className="size-9 bg-primary text-white text-xs font-bold rounded-lg shadow-sm">
                1
              </button>
              <button className="size-9 border border-slate-200 text-xs font-bold rounded-lg hover:bg-white text-corporate-text transition-colors">
                2
              </button>
              <button className="size-9 border border-slate-200 text-xs font-bold rounded-lg hover:bg-white text-corporate-text transition-colors">
                3
              </button>
              <span className="px-2 text-slate-400">...</span>
              <button className="size-9 border border-slate-200 text-xs font-bold rounded-lg hover:bg-white text-corporate-text transition-colors">
                129
              </button>
              <button className="p-2 border border-slate-200 rounded-lg hover:bg-white text-slate-400">
                <span className="material-symbols-outlined">chevron_right</span>
              </button>
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  );
};

export default InquiryDashboard;
